<template>
  <div v-loading="!initFinish" class="page-container">
    <mobileHomePage v-if="initFinish && isMobile"></mobileHomePage>
    <pcHomePage v-else-if="initFinish"></pcHomePage>
  </div>
</template>

<script>
import mobileHomePage from "@/views/mobileHomePage";
import pcHomePage from "@/views/pcHomePage";
import device from '@/mx-service/libs/utils/device'
import { aesGcmEncrypt } from '@/mx-service/libs/utils/aesGcm'
import { setLang } from '../mx-service/libs/locale'
import countryList from '@/mx-service/libs/utils/country'

export default {
  components: {
    mobileHomePage,
    pcHomePage,
  },
  data() {
    return {
      isMobile: false,
      initFinish: false
    }
  },
  methods: {
    // 根据国家设置对应多语言
    handleCountryLang(res) {
      // 国家ID列表
      const countryIdList = Object.values(countryList)
      // 国家名称列表
      const countryNameList = Object.keys(countryList)
      
      if (res.data) {
        const countryId = res.data.countryId && res.data.countryId.toLowerCase()
        const country = res.data.country
        console.log('countryId、country', countryId, country)

        // 非中国、日本，使用英文
        if (countryIdList.includes(countryId) || countryNameList.includes(country)) {
          if (countryId === 'jp' || country === '日本') {
            console.log('setJp')
            setLang('ja-JP')
            localStorage.setItem('locale', 'ja-JP')
          } else if (!(countryId === 'cn' || country === '中国')) {
            console.log('setEn')
            setLang('en-US')
            localStorage.setItem('locale', 'en-US')
          }
        }
      }
      this.initFinish = true 
    },
    // 获取当前ip位置信息
    async getiIpInfo() {
      let ts = {
        ts: new Date().getTime()
      }
      console.log('1', ts)
      ts = await aesGcmEncrypt(ts)
      console.log('2', ts)
      if (!ts) return
      const params = {
        customHeaders: {
          customaccesstoken: ts
        }
      }
      mx.request('ipInfo', params, 'mapnew5')
        .then(res => {
          try {
            this.handleCountryLang(res)
          } catch (error) {
            console.error(error)
            this.initFinish = true
          }
        })
        .catch(err => {
          console.error(err)
          this.initFinish = true
        })
    }
  },
  async created() {
    this.getiIpInfo()
    this.isMobile = device.isMobile()
  }
}
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  width: 100%;
}
</style>